import {BASE_API} from '@/constants/constants'
import axios from "axios";

axios.defaults.baseURL = BASE_API;